import Program from './Program';

export default class ProgramForm {
  constructor(
    categories = [],
    equipment = [],
    id = null,
    image = null,
    intensity_level = null,
    fitnessgoals = [],
    musclegroup = [],
    name = '',
    overview = '',
    primaryStatus = null,
    published = null,
    sets = [],
    statuses = [],
    tags = [],
    user = null,
    video = null,
    program_type = null,
    premium_required = false,
    copy = false,
  ) {
    this.categories = categories;
    this.equipment = equipment;
    this.id = id;
    this.image = image;
    this.intensity_level = intensity_level;
    this.fitnessgoals = fitnessgoals;
    this.musclegroup = musclegroup;
    this.user = user;
    this.overview = overview;
    this.primaryStatus = primaryStatus;
    this.published = published;
    this.sets = sets;
    this.statuses = statuses;
    this.tags = tags;
    this.name = name;
    this.video = video;
    this.program_type = program_type;
    this.premium_required = premium_required;
    this.copy = copy;
  }

  formatforDB() {
    const data = {
      categories: this.categories.map(item => item.toLowerCase().replace(/\s+/g, '-')),
      equipment: this.equipment,
      id: this.id,
      image: this.image ? this.image.id : null,
      intensity_level: this.intensity_level,
      fitnessgoals: this.fitnessgoals,
      musclegroup: this.musclegroup,
      name: this.name,
      overview: this.overview,
      published: this.published,
      sets: this.program_type === 'wellness' ? this.constructWellnessSets(this.sets) : this.constructSets(this.sets),
      tags: this.tags.map(item => item.value),
      user: this.user,
      video: this.video ? this.video.id : null,
      program_type: this.program_type,
      premium_required: this.premium_required,
      copy: this.copy,
    }

    return new Program(
      data.categories,
      data.equipment,
      data.id,
      data.image,
      data.intensity_level,
      data.fitnessgoals,
      data.musclegroup,
      data.name,
      data.overview,
      data.published,
      data.sets,
      data.tags,
      data.user,
      data.video,
      data.program_type,
      data.premium_required,
      data.copy,
    );
  }

  formatForForm(obj) {
    const program = new Program();
    if (obj) {
      for (const key in program) {
        if (obj.hasOwnProperty(key)) {
          program[key] = obj[key];
        }
      }
    }

    this.categories = program.categories;
    this.equipment = program.equipment;
    this.id = program.id;
    this.image = program.image;
    this.intensity_level = program.intensity_level;
    this.fitnessgoals = program.fitnessgoals;
    this.musclegroup = program.musclegroup;
    this.name = program.name;
    this.overview = program.overview || "";
    this.published = program.published;
    this.sets = program.sets;
    this.tags = program.tags.map(item => ({label: item, value: item}));
    this.user = program.user;
    this.video = program.video;
    this.program_type = program.program_type;
    this.premium_required = program.premium_required;
    this.copy = program.copy;

    this.checkValidity();
  }

  constructSets(formSets) {
    const sets = [...formSets];

    for (let i = 0; i < sets.length; i++) {
      sets[i].classes = sets[i].classes.map(item => item.id);
    }

    return sets;
  }

  constructWellnessSets(formSets) {
    const sets = [...formSets]

    const dbSets = sets.map((item, index) => {
      return {
        activities: {
          physical: item.activities.physical.map((physicalItem, physicalIndex) => {
            return physicalItem.classes ? physicalItem.classes.map(classItem => classItem.id) : [];
          }),
          wellness: item.activities.wellness.map((wellnessItem, wellnessIndex) => wellnessItem.id)
        }
      };
    });

    return dbSets;
  }

  checkValidity() {
    let primaryStatus = 'Valid';
    let statusList = {};
    const nameText = 'Program name';
    const imageText = 'Program has a thumbnail picture to represent the program';
    const categoriesText = 'Program has at least one category';
    const musclegroupText = 'Program has at least one muscle group';
    const tagsText = 'Program has at least one tag';
    const intensity_levelText = 'Program has an intensity level';

    if (this.name !== '') {
      statusList.name = {value: true, text: nameText};
    } else {
      primaryStatus = 'Invalid';
      statusList.name = {value: false, text: nameText};
    }

    // todo: add checks for valid sets, classes

    if (this.image !== null) {
      statusList.image = {value: true, text: imageText};
    } else {
      primaryStatus = 'Invalid';
      statusList.image = {value: false, text: imageText};
    }

    if (this.categories.length > 0) {
      statusList.categories = {value: true, text: categoriesText};
    } else {
      primaryStatus = 'Invalid';
      statusList.categories = {value: false, text: categoriesText};
    }

    if (this.musclegroup.length > 0) {
      statusList.musclegroup = {value: true, text: musclegroupText};
    } else {
      primaryStatus = 'Invalid';
      statusList.musclegroup = {value: false, text: musclegroupText};
    }

    if (this.tags.length > 0) {
      statusList.tags = {value: true, text: tagsText};
    } else {
      primaryStatus = 'Invalid';
      statusList.tags = {value: false, text: tagsText};
    }

    if (this.intensity_level !== null) {
      statusList.intensity_level = {value: true, text: intensity_levelText};
    } else {
      primaryStatus = 'Invalid';
      statusList.intensity_level = {value: false, text: intensity_levelText};
    }

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
